// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.psform-submit {
  background-color: var(--primary);
  color: white;
  border-radius: 5px;
  border: solid 1px var(--primary);
  padding: 10px 10px;
  font-weight: bold;
  text-align: center;
}

.psform-submit-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: -webkit-fill-available;
  margin-top: 30px;
}

.psform-input-box{
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: -webkit-fill-available;
}

.psform-input-label{
  
}

.psform-input-text{
  border-radius: 5px;
  border: solid 1px var(--border);
  padding: 10px 10px;
  width: 50%;
}

.psform{
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: -webkit-fill-available;
  padding: 20px 20px 0px 20px;
}

.psform-box-flex{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 10px;
  width: -webkit-fill-available;
}

.psform-ticker-box{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: -webkit-fill-available;
}

.ticker-img{
  width: 30px;
  height: 30px;
  border-radius: 50%;
}

.select-ticker-flex{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  width: -webkit-fill-available;
}

.select-ticker-search{
  width: 100%;
}

.ticker-results{
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 0px;
}

.select-ticker-product{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 10px;
  cursor: pointer;
  gap: 10px;
  width: 300px;
}

.ticker-desc{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
}

.delete-ticker-button{
  font-size: 10px;
  color: var(--primary);
}

.psform-ticker-selected-box{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: -webkit-fill-available;
  background-color: var(--bg-card);
  padding: 15px;
  border-radius: 5px;
}

.button-add-new{
  background-color: var(--bg-card);
  color: var(--text-primary);
  border-radius: 5px;
  border: solid 1px var(--primary);
  padding: 5px 10px;
  text-align: center;
  cursor: pointer;
  width: max-content;
  font-size: 12px;
}

.psform-description-box{
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: -webkit-fill-available;
}

.psform-input-text-full{
  border-radius: 5px;
  border: solid 1px var(--border);
  padding: 10px 10px;
  width: -webkit-fill-available;
}

.description-box-wrapper{
  background-color: var(--bg-card);
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-radius: 10px;
  padding: 10px;
  width: -webkit-fill-available;
}

.psform-input-label-text-small{
  font-size: 12px;
}

.psform-input-box-flex{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex start;
  gap: 10px;
  width: -webkit-fill-available;
}

.psform-lang-tabs{
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: max-content;
}

.psform-lang-tab{
  background-color: var(--bg-card);
  color: var(--text-primary);
  border-radius: 8px;
  font-size: 14px;
  border: solid 1px var(--border);
  padding: 8px 20px;
  font-weight: 400;
  cursor: pointer;
  text-align: center;
}

.psform-lang-tab-selected{
  background-color: var(--primary);
  color: white;
  border-radius: 8px;
  font-size: 14px;
  border: solid 1px var(--primary);
  padding: 8px 20px;
  font-weight: bold;
  cursor: pointer;
  text-align: center;
}

.psform-lang-section{
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: -webkit-fill-available;
}`, "",{"version":3,"sources":["webpack://./src/pages/structured/builder/builder.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;;AAEA;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,gCAAgC;EAChC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,gCAAgC;EAChC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B","sourcesContent":[".psform-submit {\n  background-color: var(--primary);\n  color: white;\n  border-radius: 5px;\n  border: solid 1px var(--primary);\n  padding: 10px 10px;\n  font-weight: bold;\n  text-align: center;\n}\n\n.psform-submit-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: -webkit-fill-available;\n  margin-top: 30px;\n}\n\n.psform-input-box{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.psform-input-label{\n  \n}\n\n.psform-input-text{\n  border-radius: 5px;\n  border: solid 1px var(--border);\n  padding: 10px 10px;\n  width: 50%;\n}\n\n.psform{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: -webkit-fill-available;\n  padding: 20px 20px 0px 20px;\n}\n\n.psform-box-flex{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.psform-ticker-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.ticker-img{\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n}\n\n.select-ticker-flex{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  width: -webkit-fill-available;\n}\n\n.select-ticker-search{\n  width: 100%;\n}\n\n.ticker-results{\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 10px 0px;\n}\n\n.select-ticker-product{\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  padding: 10px 10px;\n  cursor: pointer;\n  gap: 10px;\n  width: 300px;\n}\n\n.ticker-desc{\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 10px;\n}\n\n.delete-ticker-button{\n  font-size: 10px;\n  color: var(--primary);\n}\n\n.psform-ticker-selected-box{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  width: -webkit-fill-available;\n  background-color: var(--bg-card);\n  padding: 15px;\n  border-radius: 5px;\n}\n\n.button-add-new{\n  background-color: var(--bg-card);\n  color: var(--text-primary);\n  border-radius: 5px;\n  border: solid 1px var(--primary);\n  padding: 5px 10px;\n  text-align: center;\n  cursor: pointer;\n  width: max-content;\n  font-size: 12px;\n}\n\n.psform-description-box{\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n  width: -webkit-fill-available;\n}\n\n.psform-input-text-full{\n  border-radius: 5px;\n  border: solid 1px var(--border);\n  padding: 10px 10px;\n  width: -webkit-fill-available;\n}\n\n.description-box-wrapper{\n  background-color: var(--bg-card);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  border-radius: 10px;\n  padding: 10px;\n  width: -webkit-fill-available;\n}\n\n.psform-input-label-text-small{\n  font-size: 12px;\n}\n\n.psform-input-box-flex{\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex start;\n  gap: 10px;\n  width: -webkit-fill-available;\n}\n\n.psform-lang-tabs{\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n  width: max-content;\n}\n\n.psform-lang-tab{\n  background-color: var(--bg-card);\n  color: var(--text-primary);\n  border-radius: 8px;\n  font-size: 14px;\n  border: solid 1px var(--border);\n  padding: 8px 20px;\n  font-weight: 400;\n  cursor: pointer;\n  text-align: center;\n}\n\n.psform-lang-tab-selected{\n  background-color: var(--primary);\n  color: white;\n  border-radius: 8px;\n  font-size: 14px;\n  border: solid 1px var(--primary);\n  padding: 8px 20px;\n  font-weight: bold;\n  cursor: pointer;\n  text-align: center;\n}\n\n.psform-lang-section{\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  width: -webkit-fill-available;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
